/**
 * ACOUNT-COLORS.MODEL.TS
 * Customer colors for an account
 */

export class Colors {
  active: string = "#95d5df"
  brandPrimary: string = "#7d8ee0"
  brandSecondary: string = "#7d8ee0"
  brandText: string = "#FFFFFF"
  cta: string = "#1b759a"
  email: string = "#7d8ee0"

  constructor(colors: Partial<Colors> = {}) {
    Object.assign(this, colors)
  }
}
